export default {"src":"/accounts/_next/static/media/PremiumCalculator.4869742f.svg","height":460,"width":460,"blurWidth":0,"blurHeight":0};